import { KeyboardEventHandler, ReactNode } from "react";
import { FieldPath, UseFormReturn } from "react-hook-form";

import { OptionalLabel } from "@/components/OptionalLabel";
import { RichTextEditorInput } from "@/components/RichTextEditorInput";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

import { cn } from "@/lib/utils";

export const FormRichTextInput = <T extends Record<string, unknown>>({
  autoFocus,
  className,
  description,
  disabled,
  editorHeight = "260px",
  fieldName,
  form,
  inputClassName,
  label,
  onBlur,
  onKeyDown,
  optional,
  sublabel,
}: {
  autoFocus?: boolean;
  className?: string;
  description?: string;
  disabled?: boolean;
  editorHeight?: string;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  inputClassName?: string;
  label: ReactNode;
  onBlur?: () => void;
  onKeyDown?: KeyboardEventHandler;
  optional?: boolean;
  sublabel?: ReactNode;
}) => {
  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        return (
          <FormItem className={cn("text-slate-700", className)}>
            <FormLabel className="flex items-center">
              {label}
              {optional && <OptionalLabel className="ml-1.5" />}
              {sublabel && (
                <FormLabel className="ml-1.5 w-full text-xs text-slate-600">
                  {sublabel}
                </FormLabel>
              )}
            </FormLabel>
            <FormControl>
              <RichTextEditorInput
                autoFocus={autoFocus}
                containerClassName={inputClassName}
                disabled={disabled}
                editorHeight={editorHeight}
                mode={{
                  onChange: field.onChange,
                  type: "html",
                  value: field.value as string,
                }}
                onBlur={() => {
                  field.onBlur();
                  onBlur?.();
                }}
                onKeyDown={onKeyDown}
              />
            </FormControl>
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
